import { render, staticRenderFns } from "./common_ReleaseFilter.vue?vue&type=template&id=58024519&"
import script from "./common_ReleaseFilter.vue?vue&type=script&lang=js&"
export * from "./common_ReleaseFilter.vue?vue&type=script&lang=js&"
import style0 from "./common_ReleaseFilter.vue?vue&type=style&index=0&id=58024519&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports